module.exports = __webpack_public_path__ + "static/media/404.dc3cc415.svg";